import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from '@presentation/components/layout/AppLayout';
import { ProtectedRoute } from '@presentation/components/layout/ProtectedRoute';
import { LoginPage } from '@presentation/pages/LoginPage';
import { RegisterPage } from '@presentation/pages/RegisterPage';
import { ForgotPasswordPage } from '@presentation/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@presentation/pages/ResetPasswordPage';
import { TwoFactorChallengePage } from '@presentation/pages/TwoFactorChallengePage';
import { EmailVerifiedPage } from '@presentation/pages/EmailVerifiedPage';
import { VerifyEmailNoticePage } from '@presentation/pages/VerifyEmailNoticePage';
import { DashboardPage } from '@presentation/pages/DashboardPage';
import { SettingsPage } from '@presentation/pages/SettingsPage';
import { WorkspacesPage } from '@presentation/pages/WorkspacesPage';
import { CreateWorkspacePage } from '@presentation/pages/CreateWorkspacePage';
import { WorkspaceSettingsPage } from '@presentation/pages/WorkspaceSettingsPage';
import { WorkbenchPage } from '@presentation/pages/WorkbenchPage';
import { AcceptInvitationPage } from '@presentation/pages/AcceptInvitationPage';
import { NotFoundPage } from '@presentation/pages/NotFoundPage';
import { paths } from '@app/routes/paths';

export const AppRouter = () => (
  <Routes>
    <Route path={paths.root} element={<Navigate to={paths.dashboard} replace />} />
    <Route path={paths.login} element={<LoginPage />} />
    <Route path={paths.register} element={<RegisterPage />} />
    <Route path={paths.forgotPassword} element={<ForgotPasswordPage />} />
    <Route path={paths.resetPassword} element={<ResetPasswordPage />} />
    <Route path={paths.twoFactorChallenge} element={<TwoFactorChallengePage />} />
    <Route path={paths.emailVerified} element={<EmailVerifiedPage />} />

    <Route element={<ProtectedRoute />}>
      <Route element={<AppLayout />}>
        <Route path={paths.dashboard} element={<DashboardPage />} />
        <Route path={paths.settings} element={<SettingsPage />} />
        <Route path={paths.verifyEmailNotice} element={<VerifyEmailNoticePage />} />
        <Route path={paths.workspaces} element={<WorkspacesPage />} />
        <Route path={paths.newWorkspace} element={<CreateWorkspacePage />} />
        <Route path={paths.workspaceSettingsPattern} element={<WorkspaceSettingsPage />} />
        <Route path={paths.workbenchPattern} element={<WorkbenchPage />} />
      </Route>
      <Route path={paths.acceptInvitationPattern} element={<AcceptInvitationPage />} />
    </Route>

    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);
